module.exports = __webpack_public_path__ + "media/Quiz-Correct_Answer02-1.5e8d29fd.mp3";